import { useApiClient } from "@/api/client";

export const getColorsForPalette = async (uuid: string): Promise<string[]> => {
	const response = await useApiClient("profile").getColorPalette(uuid);
	if (!response.isOk()) return [];
	return (
		response.value.colors
			?.filter((c) => c.hex_value !== null)
			.map((c) => c.hex_value as string) ?? []
	);
};
